//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgCheckbox } from '../icons/Checkbox';

export function CheckboxIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCheckbox} data-qa="CheckboxIcon">
      <svg />
    </SvgIcon>
  );
}
